module.exports = __webpack_public_path__ + "efd6c54d959f63a4ad330de12fd49c1e.png";